import { JoinErrorKind } from './callToken';

const messages: { [language: string]: { [kind in JoinErrorKind]: string } } = {
  en: {
    invalidLink: 'This video call link is invalid. Please request a new link.',
    expiredLink: 'This video call link is invalid or has expired. Please open a new link to join.',
    callEnded: 'This call has already ended.',
    unavailable: 'Unable to join the video call. Please try again.',
  },
  fr: {
    invalidLink: 'Ce lien d’appel vidéo est invalide. Veuillez demander un nouveau lien.',
    expiredLink:
      'Ce lien d’appel vidéo est invalide ou a expiré. Veuillez ouvrir un nouveau lien pour vous joindre à l’appel.',
    callEnded: 'Cet appel est déjà terminé.',
    unavailable: 'Impossible de vous joindre à l’appel vidéo. Veuillez réessayer.',
  },
};

export function getJoinErrorMessage(kind: JoinErrorKind) {
  const language = (window.navigator.language || '').toLowerCase().startsWith('fr') ? 'fr' : 'en';
  return messages[language][kind];
}
